import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Login from './pages/Login';
import Searches from './pages/Searches';
import PrivateRoute from './components/PrivateRoute';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/searches"
            element={
              <PrivateRoute>
                <Searches />
              </PrivateRoute>
            }
          />
          <Route path="/" element={<Navigate to="/searches" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
